import { Link } from "react-router-dom";

function ObWelcome({ onNext, userName }) {
    const handleClick = () => {
        onNext();
    };

    return (
        <div>
            <h1>Hallo {userName ?? 'Nutzer'}, willkommen bei Yaccount!</h1>
            <h2>Schön dich bei uns begrüßen zu können.</h2>
            <p>
                Damit du direkt starten kannst, trag am besten hier direkt die Daten ein, 
                die du für die Erstellung der Rechnungen benötigst.
                Wenn du nicht alles parat hast, kein Problem. 
                Du kannst das auch überspringen oder die Daten jederzeit in den Einstellungen anpassen und ergänzen.
            </p>
            <div className="linkContainer">
                <Link to='/settings'>Abbrechen</Link>
                <Link onClick={handleClick}>Weiter</Link>
            </div>
        </div>
    );
}

export default ObWelcome;